var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
export var connectSsr = function (config) {
    if (config === void 0) { config = {}; }
    return function (WrappedComponent) {
        var C = /** @class */ (function (_super) {
            __extends(C, _super);
            function C(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    d: {},
                    loading: true
                };
                return _this;
            }
            C.getInitialProps = function (props) {
                return __awaiter(this, void 0, void 0, function () {
                    var c;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(WrappedComponent &&
                                    typeof WrappedComponent['getInitialProps'] === 'function')) return [3 /*break*/, 2];
                                return [4 /*yield*/, WrappedComponent.getInitialProps(props)];
                            case 1:
                                c = _a.sent();
                                return [2 /*return*/, __assign({}, c, { loading: false })];
                            case 2: return [2 /*return*/, {}];
                        }
                    });
                });
            };
            C.getID = function () {
                return config.displayName;
            };
            C.prototype.getInitData = function () {
                if (config.displayName &&
                    typeof window.__INIT_DATA__ !== 'undefined' &&
                    window.__INIT_DATA__[config.displayName]) {
                    return window.__INIT_DATA__[config.displayName];
                }
                return null;
            };
            C.prototype.componentWillReceiveProps = function (nextProps) {
                return __awaiter(this, void 0, void 0, function () {
                    var d;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(nextProps.location.pathname !== this.props.location.pathname ||
                                    nextProps.location.query !== this.props.location.query)) return [3 /*break*/, 2];
                                this.setState({ loading: true });
                                return [4 /*yield*/, C.getInitialProps(nextProps)];
                            case 1:
                                d = _a.sent();
                                return [2 /*return*/, this.setState({ d: d, loading: false })];
                            case 2: return [2 /*return*/];
                        }
                    });
                });
            };
            C.prototype.componentDidMount = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var data, d;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                data = this.getInitData();
                                if (!(data === null)) return [3 /*break*/, 2];
                                this.setState({ loading: true });
                                return [4 /*yield*/, C.getInitialProps(this.props)];
                            case 1:
                                d = _a.sent();
                                return [2 /*return*/, this.setState({ d: d, loading: false })];
                            case 2: return [2 /*return*/, this.setState({
                                    d: data,
                                    loading: false
                                })];
                        }
                    });
                });
            };
            C.prototype.render = function () {
                var data = this.getInitData() || {};
                return React.createElement(WrappedComponent, __assign({}, data, this.state.d, this.props));
            };
            return C;
        }(React.Component));
        return C;
    };
};
export var ssrContext = React.createContext({
    register: function (cb) { }
});
/**
 * Effects with Cleanup not supported
 */
export var useAsyncData = function (cb, deps) {
    React.useContext(ssrContext).register(cb);
    React.useEffect(function () {
        cb();
    }, deps);
};
//# sourceMappingURL=SSR.js.map